module.exports = __webpack_public_path__ + "media/images/Facebook_Transparent-5e094b5bd530f22f02fa2458c9f14ea6.png";